// extracted by mini-css-extract-plugin
export default {"dialogClassName":"prevent-unsaved-box-builder-progress-popup__dialogClassName___vv7ev"};